import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { ListItemIcon, ListSubheader, Grid } from '@mui/material'
import DeletePvInstallation from './DeletePvInstallation'
import EditPvInstallation from './EditPvInstallation'
import PvInstallationIcon from '@mui/icons-material/SolarPower'
import schema from '../../schemas/pvinstallation.json'
import { JSONSchema7 } from 'json-schema'
import { PvInstallation } from '../../interfaces/pvinstallation'
import CreatePvInstallation from './CreatePvInstallation'

export interface Props {
  disabled: boolean
  data: PvInstallation[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function PvInstallationList({ disabled, data, setData }: Props) {
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'PV Installations'}
            <CreatePvInstallation disabled={disabled} data={data} schema={schema as JSONSchema7} setData={setData} />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: PvInstallation, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditPvInstallation disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <DeletePvInstallation disabled={disabled} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>
                <PvInstallationIcon />
              </ListItemIcon>
              <ListItemText
                primary={obj.name}
                secondary={`Installed power: ${obj.n_panels} * ${obj.P_STC} W`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
